export default {
  Gate__GATE: ({ gate }) => `Gate: ${gate ?? "N/A"}`,
};
